// KWANKGM04080_契約申込確認
import React from 'react';
import TopArea from '../../molecules/TopArea';
import { StepNavigation as StepType, ContractInfo } from '../../types/Template';
import LoadingModal from '../../molecules/LoadingModal';
import FooterContractApplicationConfirmation from '../../organisms/FooterContractApplicationConfirmation';
import ContractApplicationConfirmationBody from '../../organisms/ContractApplicationConfirmBody';
interface Props {
  step_navigation: StepType;
  reception_cd: string;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  looks_inactive: boolean;
  reception_id: number;
  movePrevStep: () => void;
  moveNextStep: () => void;
  is_loading: boolean;
  display_status: boolean;
  refusalExecution: () => void;
  contractExecution: () => void;
  status_code: number;
  contract_info: ContractInfo;
}

const ContractApplicationConfirmation: React.FC<Props> = ({
  step_navigation,
  reception_cd,
  label,
  status_name,
  display_reception_cd,
  guide_text,
  reception_id,
  movePrevStep,
  moveNextStep,
  is_loading,
  display_status,
  refusalExecution,
  contractExecution,
  status_code,
  contract_info,
  looks_inactive,
}) => {
  return (
    <>
      <TopArea
        step_navigation={step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={false}
        guide_text={guide_text}
        display_status={false}
      />
      <ContractApplicationConfirmationBody
        contract_info={contract_info}
        looks_inactive={looks_inactive}
      />
      <FooterContractApplicationConfirmation
        reception_cd={reception_cd}
        reception_id={reception_id}
        movePrevStep={movePrevStep}
        moveNextStep={moveNextStep}
        declineExecution={refusalExecution}
        contractExecution={contractExecution}
        status_code={status_code}
      />
      <LoadingModal show={is_loading} />
    </>
  );
};

export default ContractApplicationConfirmation;
